<div class="modal-header">
    <h2>TSA Security Threat Response History</h2>
</div>
<div class="modal-body">
    <tsa-security-threat-history [customerNumberId]="data.customerNumberId" [editorEnabled]="false" [showHistoryEnabled]="false"></tsa-security-threat-history>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="close()">Close</button>
    </div>
</div>